import React, { useEffect, useRef } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useElementsCoordsContext } from '@hooks';
import { useStylesTabs, useStylesTab } from './styles';

const MainMenuChips = ({ tabValue, fetchedStructure, onChipTab }) => {
  const tabsRef = useRef();
  const classesTabs = useStylesTabs();
  const classesTab = useStylesTab();
  const { setElementsCoords } = useElementsCoordsContext();

  useEffect(() => {
    setElementsCoords({
      mainMenuChips: tabsRef.current.getBoundingClientRect(),
    });
    // eslint-disable-next-line
  }, []);

  return (
    <div ref={tabsRef}>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={tabValue.index}
        classes={classesTabs}
      >
        {fetchedStructure?.map((data, index) => (
          <Tab
            key={data.id}
            disableRipple
            label={data.name}
            classes={classesTab}
            onClick={() => onChipTab({ id: data.id, index, items: data.name })}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default MainMenuChips;
